export const AppRoutes = {
  login: '',
  onboard: '/onboard',
  resetpassword: '/resetpassword',
  forgotPassword: '/forgotPassword',
  dashboard: '/dashboard',
  liveJobs: '/job/liveJob',
  addEditJob: '/job/addEdit',
  alarmedJobs: '/job/alarms',
  orderConfirmedJobs: '/job/orderConfirmed',
  completedJobs: '/job/completed',
  jobCompleted: '/job/jobCompleted',
  cancelledJobs: '/job/cancelledJobs',
  jobHistory: '/job/jobHistory',
  invoiceSent: '/job/invoiceSent',
  vdrCOC: '/job/vdrCOC',
  repeatedJobsDueHistory: '/job/repeatedJobsDue',
  jobPublishers: '/publishers',
  addJobPublisher: '/publisher/add',
  editUser: '/users/edit',
  companies: '/companies',
  engineers: '/engineers',
  jobDescriptions: '/descriptions',
  spares: '/spares',
  agents: '/agents',
  accountant: '/accountants',
  logistics: '/logistics',
  logisticJobs: '/job/logisticJobs',
  admins: '/admins',
  sparePrepare: '/job/sparePrepare',
  spareVerified: '/job/spareVerified',
  country: '/countries',
};
